<template>
  <div
    class="swipper"
    @touchstart="touchstart"
  >
    <slot />
  </div>
</template>

<script>
const point = {
  // origin
  ox: 0,
  oy: 0,
  // origin delta
  odx: 0,
  ody: 0,
  // current
  x: 0,
  y: 0,
  // current delta
  dx: 0,
  dy: 0,

  init(x, y) {
    this.ox = x;
    this.oy = y;
    this.x = x;
    this.y = y;
    this.odx = 0;
    this.ody = 0;
    this.dx = 0;
    this.dy = 0;
  },

  set(x, y) {
    this.dx = x - this.x;
    this.dy = y - this.y;
    this.x = x;
    this.y = y;
    this.odx = this.x - this.ox;
    this.ody = this.y - this.oy;
  },
};

function xyArrayFromTouchEvent(e) {
  if (!e.touches || !e.touches[0]) return [0, 0];
  return [e.touches[0].clientX, e.touches[0].clientY];
}

export default {
  beforeDestroy() {
    this.removeListeners();
  },

  methods: {
    touchstart(e) {
      point.init(...xyArrayFromTouchEvent(e));
      window.addEventListener('touchmove', this.touchmove, { passive: false });
      window.addEventListener('touchend', this.touchend, { passive: false });
    },

    touchend() {
      this.removeListeners();
      this.$emit('swipeend', { type: 'swipeend', deltaX: point.odx, deltaY: point.ody });
    },

    touchmove(e) {
      point.set(...xyArrayFromTouchEvent(e));

      if (Math.abs(point.ody) > 100) {
        this.removeListeners();
        this.$emit('swipeabort', { type: 'swipeabort', deltaX: point.odx, deltaY: point.ody });
        return;
      }

      e.preventDefault();
      this.$emit('swipe', { type: 'swipe', deltaX: point.odx, deltaY: point.ody });
    },

    removeListeners() {
      window.removeEventListener('touchmove', this.touchmove);
      window.removeEventListener('touchend', this.touchend);
    },
  },
};
</script>
